// Backend'den gelen status'u kullanıcının seçtiği dilde gösterir.
// `locale.statuses` sözlüğünde code bulunamazsa fallback olarak backend'ten gelen ad döner.
export function statusLabel(locale, code, fallbackName) {
  if (!code) return fallbackName || '';
  const dict = locale?.statuses || {};
  return dict[code] || fallbackName || code;
}
